import React from 'react';

/** Paw from `/assets/paw.svg`; selected reads black, unselected muted grey. */
export const ChipPaw = ({ selected }) => (
  <img
    src="/assets/paw.svg"
    alt=""
    draggable={false}
    aria-hidden
    className={`h-[14px] w-[14px] shrink-0 object-contain ${selected ? 'brightness-0' : 'opacity-[0.38] grayscale'}`}
  />
);

export const filterChipBtn = (selected) =>
  `flex items-center justify-center gap-1.5 rounded-full border text-center transition-colors ${
    selected
      ? 'border-black bg-white text-black'
      : 'border-[#E5E3DF] bg-transparent text-[#9B9B9B]'
  }`;
